import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-cy", "disabled"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    id: _ctx.id,
    type: "button",
    "data-cy": _ctx.dataCy,
    disabled: _ctx.disabled,
    class: _normalizeClass({
      'tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-px-[8px] tw-py-[2px] tw-bg-[#387DFF] hover:tw-bg-[#211F58] tw-cursor-pointer tw-rounded-[50%] plus-container tw-z-[1]': true,
      '!tw-cursor-not-allowed !tw-bg-[#b7b7b7]': _ctx.disabled,
    })
  }, [
    _createElementVNode("img", {
      class: "tw-h-[10px] tw-w-[10px]",
      src: _ctx.src,
      alt: "icon"
    }, null, 8, _hoisted_2)
  ], 10, _hoisted_1))
}